/*
### Custom Events ###
1. product:added
    Event Trigger When a product is added to the cart.

2. variant:changed
    Event Trigger When a product variant is changed on Product Page.

3. card:quantity:update
    Event Trigger When a quantity is updated on quantity counter.
    it will be triggered on input field.
    note: it don't have any effect on cart.

4. cart:updated
    Event Trigger When a Cart is updated.

### Custom Functions ###
1. swAddToCart(productId, quantity)
    Add a product to the cart.
    @param {number} productId - Product ID.
    @param {number} quantity - Product Quantity.
    // This will add a product to the cart and return the cart data.
    swAddToCart(123456789, 1).then(cartData => { console.log(cartData); });

2. swCartFetch()
    Fetch Cart Data.
    @return {Promise} - Cart Data.
    // This will log the cart data 
    swCartFetch().then(cartData => { console.log(cartData); });

3. swCartUpdate(productId, quantity)
    Update a product quantity in the cart.
    @param {number} productId - Product ID.
    @param {number} quantity - Product Quantity.
    // This will update the product quantity in the cart and return the cart data.
    swCartUpdate(123456789, 2).then(cartData => { console.log(cartData); });

4. resetPlayingVideos()
    Use for playing video stoped

### Popup IDs ###
1. cart_delete_popup
    This id used to open Card Product Card Remove Popup
    Also Add "[sw-delet-product-outer]" to wraper of the Card
*/

$(document).ready(function () {
  // ----------- Share Button -----------
  $("[data-share-page-link]").on("click", function (e) {
    e.preventDefault();

    if (navigator.share) {
      navigator
        .share({
          title: document.title,
          url: window.location.href,
        })
        .then(() => console.log("Thanks for sharing!"))
        .catch((err) => console.log("Share failed:", err));
    } else {
      $("#tip").show();
    }
  });

  // ------------------------ Sticky Header ------------------------
  $(function () {
    const $sticky = $("[data-sticky-header]");
    const $static = $("[data-static-header]");
    let lastScroll = 0;
    const inView = () => $static[0].getBoundingClientRect().bottom > 0;
    $(window).on("scroll", () => {
      resetPlayingVideos();
      const st = $(this).scrollTop();
      if (inView()) {
        $sticky.stop(true).slideUp(250);
      } else {
        st < lastScroll
          ? $sticky.stop(true).slideDown(250)
          : $sticky.stop(true).slideUp(250);
      }
      lastScroll = st;
    });
    $sticky.hide();
  });

  // ------------------------ Hero Section Height Set 100vh With Calculation Header and Announcement Bar ------------------------
  // function setHeroHeight() {
  //   const winWidth = $(window).width();
  //   const heroSection = $('.hero_main_wrapper');
  //   if (winWidth >= 1024) {
  //     const announcement = $('#announcement_bar_set')[0]?.getBoundingClientRect().height || 0;
  //     const header = $('[data-static-header]')[0]?.getBoundingClientRect().height || 0;
  //     heroSection.css({
  //       height: `calc(100vh - ${announcement + header}px)`,
  //       visibility: 'visible'
  //     });
  //   } else {
  //     heroSection.css({ height: '', visibility: 'visible' });
  //   }
  // }
  // Document ready shortcut — page ready hone ke baad code run kare.
  // $(() => {
  //   setHeroHeight();
  //   $(window).on('resize', setHeroHeight);
  // });

  // ------------------------ Reset Play Video ------------------------
  function resetPlayingVideos() {
    $(".video_frame").each(function () {
      var $video = $(this).find("video").get(0);
      if ($video) {
        $video.pause();
        $video.currentTime = 0;
      }
    });
  }

  // ------------------------ Faq's Tabing ------------------------
  $('.faq_item').hide();
  let selectedTab =  $('[data-faq-tab]:checked').data('faq-tab');
  if ($(`.faq_item[sw-faq-id="${selectedTab}"]`).length)
    $(`.faq_item[sw-faq-id="${selectedTab}"]`).fadeIn();
  else
    $(`.faq_item[sw-faq-id="default"]`).fadeIn();
  $('[data-faq-tab]').on('change', (el) => {
    $('.faq_item').hide();
    if ($(`.faq_item[sw-faq-id="${el.currentTarget.dataset.faqTab}"]`).length)
      $(`.faq_item[sw-faq-id="${el.currentTarget.dataset.faqTab}"]`).fadeIn();
    else
      $(`.faq_item[sw-faq-id="default"]`).fadeIn();
  });

  // ------------------------ Product Popups ------------------------
  $("[data-popup-trigger]").on("click", function () {
    $(".none_drawer").fadeOut(300);
    var popupId = $(this).data("popup-trigger");
    swPopOpen(popupId);
  });

  // ------------------------ Search page Show result input ------------------------
  // function updateSearchResult() {
  //   let text = $("#search-in-template").val().trim();
  //   $("#search-result-title").text(`Found 0 Results for “${text || ""}”`).show();
  // }
  // $("#search-in-template").on("input", updateSearchResult).trigger("input");
  // $("[data-reset-search-result]").on("click", function() {
  //     $("#search-in-template").val("").trigger("input");
  // });

  // ------------------------ User Button ------------------------
  $(".user_btn").on("click", function (event) {
    event.stopPropagation();
    $(".user_box").fadeToggle(300);
  });

  $(document).on("click", function (event) {
    if (!$(event.target).closest(".user_box, .user_btn").length || $(event.target).closest(".user_box button").length) {
      $(".user_box").fadeOut(300);
    }
  });
  $(window).on("scroll", function () {
    if ($(".user_box").is(":visible")) {
      $(".user_box").fadeOut(300);
    }
  });

  // $(".contact_faq_tab_button").click(function() {
  //   let selectedTab = $(this).data("faq-tab");
  //   $(".faq_item").hide();
  //   $(`.faq_item[data-faq-category="${selectedTab}"]`).fadeIn();
  // });
  // $(".contact_faq_tab_button:first").trigger("click");

  // ------------------------ Faq's Questions and Answers ------------------------
  $("[data-answer-box]").first().show();
  $("[data-question-btn] .plus_icon").first().hide().siblings("[data-question-btn] .minus_icon").show();
  $("[data-question-btn]").click(function () {
    var btnId = $(this).data("question-btn");
    var $currentBox = $("[data-answer-box='" + btnId + "']");
    var isVisible = $currentBox.is(":visible");
    $("[data-answer-box]").slideUp(500);
    $("[data-question-btn] .plus_icon").show().siblings(".minus_icon").hide();
    if (!isVisible) {
      $currentBox.slideDown(500);
      $("[data-question-btn='" + btnId + "'] .plus_icon").hide().siblings(".minus_icon").show();
    }
  });

  // ----------- Product counter (Increase & Decrease) button -----------
  $("[data-invent-counter]").on("click", (el) => {
    let target = "";
    if (el.currentTarget.classList.contains("cart_drawer")) target = "drawer";
    quantityCounter(el.currentTarget);
  });

  // product card swiper
  $("[sw-quick-var]").on("change", (el) => {
    $(el.currentTarget).parents(".quick_item_box").find("[sw-quick-id]").attr("sw-quick-id", el.currentTarget.value);
  });
  $(document).on("click", "[sw-quick-id]", (el) => {
    el.preventDefault();
    if (el.currentTarget.hasAttribute("disabled")) return;
    swAddToCart(el.currentTarget.getAttribute("sw-quick-id")).then((data) => {
      $(".quick_view_box").fadeOut(200);
    });
  });
  $("[sw-quick-trigger]").on("click", (el) => {
    el.preventDefault();
    $(".quick_view_box").fadeOut(200);
    $(el.currentTarget).closest(".product_card_box").find(".quick_view_box").css("display", "flex").hide()
      .fadeIn(800);
  });
  $(".quick_view_box").on("click", (el) => {
    el.preventDefault();
    $(el.currentTarget).fadeOut(200);
  });
  $(".quick_item_box").on("click", (el) => {
    el.stopPropagation();
  });

  // ------------------------ Mega Menu Toggle ------------------------
  $(".menu_open_btn").on("click", function () {
    $(".menu_box_wrap").slideToggle(600);
    $("body").css("overflow", "hidden");
    updateHeaderPadding();
  });
  $(".menu_close_btn").on("click", function () {
    $(".menu_box_wrap").slideToggle(600);
    $("body").css("overflow", "unset");
  });

  // Product Delet Popup
  $("[sw-cart-remove]").on("click", (el) => {
    swCartRemove(el.currentTarget);
  });
  $("#cart_delete_popup .remove_btn").on("click", (el) => {
    let productId = el.currentTarget.dataset.productId;
    swCartUpdate(productId, 0).then((cartData) => {
      if (cartData) {
        $("[cart-drawer-heading-count]").html(cartData.item_count);
        $("[sw-total-wraper]").find(".total_price").html(Shopify.formatMoney(cartData.total_price));
        if (cartData.item_count == 0 && window.location.pathname == window.routes.cart_url) {
          $(".empty_cart_page").removeClass("d_none");
          $(".cart_box_wrap, .continue_shopping").removeClass("d_flex").addClass("d_none");
        }
      } else {
        location.reload();
      }
      $('[sw-cart-remove="' + productId + '"]').parents("[sw-delet-product-outer]").remove();
    });
    swPopClose();
    $("[cart-drawer-item].cart_product_loader").addClass("show");
    setTimeout(() => {
      swCartDrawerUpdate();
    }, 1000);
  });
  // $('[sw-search-input]').on('focusout',()=>{
  //   $(".suggestions-list").css("display", "none");
  // });
  $("[sw-search-input]").on("keyup", (el) => {
    var query = el.currentTarget.value.trim();
    if (query.length > 2) {
      fetch(
        window.Shopify.routes.root +
          "search/suggest.json?q=" +
          query +
          "&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title"
      )
        .then((response) => response.json())
        .then((data) => {
          let suggestions = data.resources.results.products;
          $(".suggestions-list").html("");
          if (el.keyCode == 13) {
            el.preventDefault();
            window.location.href = "/search?q=" + el.currentTarget.value.trim();
          } else if (el.keyCode == 27) {
            el.preventDefault();
            setTimeout(() => {
              swSearchClear();
            }, 600);
            $(".search_box_wrap").fadeOut(300).animate({ top: "-100%" }, 500);
            $("#backdrop_overlay").removeClass("z_index_100").fadeOut(300);
            $("body").css("overflow", "unset");
          }
          if (suggestions.length > 0) {
            $(".suggestions-list").css("display", "flex");
            suggestions.forEach(function (product, i) {
              var suggestionItem = document.createElement("a");
              suggestionItem.classList.add("suggestion-item");
              suggestionItem.innerHTML = product.title;
              suggestionItem.href = product.url;
              $(".suggestions-list").append(suggestionItem);
              if (i + 1 == suggestions.length) {
                suggestionItem.innerHTML = "Search All " + query + " -->";
                suggestionItem.href = "/search?q=" + query;
                $(".suggestions-list").append(suggestionItem);
              }
            });
          } else {
            $(".suggestions-list")
              .css("display", "flex")
              .html("<p>No Result Found</p>");
          }
        })
        .catch((error) =>
          console.error("Error fetching search suggestions:", error)
        );
    } else {
      $(".suggestions-list")
        .css("display", "flex")
        .html("<p>Write at least 3 characters</p>");
    }
    // fetch(window.Shopify.routes.root + "search/suggest.json?q="+searchQuery+"&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title")
    // .then((response) => response.json())
    // .then((suggestions) => {
    //     const productSuggestions = suggestions.resources.results.products;
    //     ;
    //     if (productSuggestions.length > 0) {
    //         productSuggestions.forEach((product)=>{
    //             console.log(product);
    //         });
    //     }
    // }
    // );
  });

  // cart drawer
  $(document).on("product:added", (el) => {
    swCartDrawerOpen();
    $("[cart-drawer-item].cart_product_loader").addClass("show");
    setTimeout(() => {
      swCartDrawerUpdate();
    }, 1000);
  });

  // blog tabs
  $("[sw-blog-trg]").on("click", (el) => {
    let targetVal = el.currentTarget.value;
    if (targetVal == "all") $("[sw-blog-wrap]").show(500);
    else {
      $("[sw-blog-wrap]").hide(500);
      $(`[${el.currentTarget.value}]`).show(500);
    }
  });
});

// quantity counter
function quantityCounter(el) {
  const input_el = el.parentElement.children[1];
  let currentQun = parseInt(input_el.value);
  const par_el = $(el).parents(".cart_drawer_wrap");
  $(par_el).find(".cart_product_loader").addClass("show");
  if (el.dataset.inventCounter == "plus") ++currentQun;
  else if (el.dataset.inventCounter == "minus") {
    if (currentQun == 1) {
      $("#backdrop_overlay").addClass("sw_z_111");
      setTimeout(() => {
        swPopOpen("counter_decrease_popup");
      }, 1000);
    }
    else --currentQun;
  }
  setTimeout(() => {
    input_el.value = currentQun;
    input_el.dispatchEvent(
      new Event("card:quantity:update", { bubbles: true })
    );
    if (par_el) {
      $(par_el).find(".cart_product_loader").removeClass("show");
    }
  }, 1000);
}

// cart drawer update
function swCartDrawerUpdate() {
  swCartFetch().then((cart) => {
    if (cart.item_count > 0) {
      $(".cart_product_loader").addClass("show");
      $("[cart-drawer-products]").html("");
      let product_html,
        product_wrap = "";
      cart.items.forEach((item, index) => {
        product_html = `
                <div class="product_box d_grid" sw-delet-product-outer>
                        <div class="product_details_box">
                            <a href="${item.url}">
                                <img src="${item.image}" alt="${item.image.alt}" height="100%" width="100%" style="object-fit: cover;"> 
                            </a>
                            <div class="product_details align_self_center">
                                <p class="product_title text_black">${
                                  item.product_title
                                }</p>
                                 ${
                                   item.options_with_values &&
                                   item.options_with_values.length > 0
                                     ? `
                                    <p class="product_size text_black sw_dots_flex">
                                        ${item.options_with_values
                                          .map(
                                            (lineItem, index) => `
                                            ${lineItem.value}
                                            ${
                                              index !==
                                              item.options_with_values.length -
                                                1
                                                ? '<span class="sw_dot"></span>'
                                                : ""
                                            }
                                        `
                                          )
                                          .join("")}
                                    </p>
                                `
                                     : ""
                                 }
                                <div class="drawer_mob_price_box d_none align_center">
                                <p class="price text_black">${Shopify.formatMoney(
                                  item.original_price
                                )}</p>
                                </div>
                                <div class="cart_dra_add_product show_desktop align_center">
                                    <p class="decrease_btn cart_drawer" onClick="quantityCounter(this)" data-invent-counter="minus">
                                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18 12L6 12" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </p>
                                    <input type="text" data-product-id="${item.id}" data-price="${item.original_price}" cart-quantity-item value="${item.quantity}" class="text_center" min="1" name="quantity" readonly>
                                    <p class="increase_btn cart_drawer" onClick="quantityCounter(this)" data-invent-counter="plus">
                                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 6V18M18 12L6 12" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="product_price_box align_center">
                            <div class="price_box">                                 
                                <p class="price text_black">${Shopify.formatMoney(
                                  item.original_price
                                )}</p>
                            </div>
                            <button class="product_del_btn" onclick="swCartRemove(this)" sw-cart-remove="${item.id}">
                                <svg width="28" height="28" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.25 10V22.5C6.25 25.2614 8.48858 27.5 11.25 27.5H18.75C21.5114 27.5 23.75 25.2614 23.75 22.5V10M17.5 13.75V21.25M12.5 13.75L12.5 21.25M20 6.25L18.2422 3.61325C17.7785 2.91775 16.9979 2.5 16.162 2.5H13.838C13.0021 2.5 12.2215 2.91775 11.7578 3.61325L10 6.25M20 6.25H10M20 6.25H26.25M10 6.25H3.75" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                        </div>
                        <div class="cart_mob_quantity_box d_none" sw-delet-product-outer>
                            <div class="cart_dra_add_product align_center justify_center">
                                <p class="decrease_btn cart_drawer" onClick="quantityCounter(this)" data-invent-counter="minus">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 12L6 12" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </p>
                                <input type="text" data-product-id="${
                                  item.id
                                }" data-price="${
          item.original_price
        }" cart-quantity-item value="${
          item.quantity
        }" class="text_center" min="1" name="quantity" readonly>
                                <p class="increase_btn cart_drawer" onClick="quantityCounter(this)" data-invent-counter="plus">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 6V18M18 12L6 12" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </p>
                            </div>
                            <button class="product_del_btn" onclick="swCartRemove(this)" sw-cart-remove="${
                              item.id
                            }">
                                <svg width="24" height="24" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.25 10V22.5C6.25 25.2614 8.48858 27.5 11.25 27.5H18.75C21.5114 27.5 23.75 25.2614 23.75 22.5V10M17.5 13.75V21.25M12.5 13.75L12.5 21.25M20 6.25L18.2422 3.61325C17.7785 2.91775 16.9979 2.5 16.162 2.5H13.838C13.0021 2.5 12.2215 2.91775 11.7578 3.61325L10 6.25M20 6.25H10M20 6.25H26.25M10 6.25H3.75" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>`;
        product_wrap = product_wrap + product_html;
      });
      $("[cart-drawer-item]").addClass("active");
      $("[empty-cart-drawer]").removeClass("active");
      setTimeout(() => {
        $("[cart-drawer-heading]").html("Your Cart(" + cart.item_count + " items)");
        $("[cart-drawer-heading-count]").html( cart.item_count );
        $("[cart-drawer-products]").html(product_wrap);
        $("[sw-total-wraper]")
          .find(".total_price")
          .html(Shopify.formatMoney(cart.total_price));
        $(".cart_product_loader").removeClass("show");
      }, 600);
    } else {
      $(".cart_product_loader").removeClass("show");
      $("[cart-drawer-item]").removeClass("active");
      $("[empty-cart-drawer]").addClass("active");
    }
    // window.reload();
  });
}

// product popup
function swPopOpen(popupId) {
  $("#" + popupId).css("display", "flex").fadeIn(300).addClass("active");
  $("#backdrop_overlay").fadeIn(300).addClass("z_index_100");
  $("body").css("overflow", "hidden");
}

function swCartRemove(el) {
  let varId = parseInt(el.getAttribute("sw-cart-remove"));
  document.querySelector("#cart_delete_popup .remove_btn").dataset.productId = varId;
  const par_el = $(el).parents(".cart_drawer_wrap");
  if (par_el) {
    $(par_el).find(".cart_product_loader").addClass("show");
    $("#backdrop_overlay").addClass("sw_z_111");
    setTimeout(() => {
      swPopOpen("cart_delete_popup");
    }, 1000);
  } else {
    swPopOpen("cart_delete_popup");
  }
}

function swPopClose() {
  if ($(".cart_drawer_wrap").hasClass("active")) {
    if ($("#cart_delete_popup").hasClass("active") || $("#counter_decrease_popup").hasClass("active")) {
      $(".cart_product_loader").removeClass("show");
      $("[sw-pop-wrap]").fadeOut(300);
      $("#backdrop_overlay").removeClass("sw_z_111");
      $("[sw-pop-wrap]").removeClass("active");
    } else {
      swCartDrawerClose();
    }
  } else {
    $("[sw-pop-wrap]").fadeOut(300);
    $(".search_box_wrap").fadeOut(300).animate({ top: "-100%" }, 500);
    $("#backdrop_overlay").removeClass("z_index_100 sw_z_111").fadeOut(300);
    $("body").css("overflow", "unset");
    setTimeout(() => {
      $('#search-in-template').closest('form').trigger('reset');
    }, 600);
  }
}

// ------------ Header padding, when show announcement bar ------------ 
function updateHeaderPadding() {
  const $headerTarget = $("[header-top-padding]");
  const $announcement = $("#announcement_bar_set");

  if (!$announcement.length) {
    $headerTarget.removeClass("header_top_padding");
    return;
  }

  const isVisible = $announcement[0].getBoundingClientRect().bottom > 0;

  if (isVisible) {
    $headerTarget.addClass("header_top_padding");
  } else {
    $headerTarget.removeClass("header_top_padding");
  }
}

// Search open
function swSearchOpen() {
  $(".none_drawer").fadeOut(300);
  $("#backdrop_overlay").fadeIn(300);
  $(".search_box_wrap").fadeIn(300).animate({ top: 0 }, 400);
  $("body").css("overflow", "hidden");

  updateHeaderPadding();
}

function swSearchClear() {
  $("[sw-search-input]").val("");
  $(".suggestions-list").html("").hide();
}

// Cart Drawer global functions
function swCartDrawerOpen() {
  $(".none_drawer").fadeOut(300);
  $(".search_box_wrap").fadeOut(300).animate({ top: "-100%" }, 500);
  $("#backdrop_overlay").addClass("z_index_100").fadeIn(300);
  $(".cart_drawer_wrap").addClass("active").fadeIn(300).animate({ right: "0" }, 500);
  $("body").css("overflow", "hidden");
}

function swCartDrawerClose() {
  $(".cart_drawer_wrap").removeClass("active").animate({ right: "-100%" }, 500).fadeOut(300, function () {
    $("#backdrop_overlay").removeClass("z_index_100").fadeOut(300);
    $("body").css("overflow", "unset");
  });
}

// product add to cart
async function swAddToCart(productId, quantity) {
  quantity = quantity | 1;
  try {
    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: productId, quantity: quantity }),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const data = await response.json();
    document.dispatchEvent(new CustomEvent("product:added", { detail: data }));
    return data;
  } catch (error) {
    console.error("Error adding product to cart:", error);
    return null;
  }
}

// cart fetch
async function swCartFetch() {
  try {
    const response = await fetch(window.Shopify.routes.root + "cart.js");
    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Failed to fetch cart data", error);
    return null;
  }
}

// cart update
async function swCartUpdate(productId, quantity) {
  productId = parseInt(productId);
  quantity = parseInt(quantity);
  try {
    const response = await fetch(
      window.Shopify.routes.root + "cart/update.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [productId]: quantity } }),
      }
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }
    const data = await response.json();
    if(data.item_count == 0){
        $('.header_menu_icons .cart_icon').hide('fast');
    }else{ 
        $('.header_menu_icons .cart_icon').show('fast');
    }
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: data }));
    return data;
  } catch (error) {
    console.error("Error updating cart:", error);
    return null;
  }
}
$(window).on("load", function () {
  $("#backdrop_overlay").hide().removeClass("z_index_100 sw_z_111");
  $(".none_drawer, .menu_box_wrap, .quick_view_box").hide().removeClass("active");
  $("body").css("overflow", "unset");
});